import React, { Fragment } from "react";
import { Footerdark, PageLayout } from "../../../Constant";
import AccountForm from "./AccountForm";

const AccountAdd = () => {
    return (
        <Fragment>
            <AccountForm mainTitle={Footerdark} title={Footerdark} parent={PageLayout} />         
        </Fragment>
    )
}
export default AccountAdd;